import { render, staticRenderFns } from "./Index-FiscalIssuance.vue?vue&type=template&id=09d65fec&scoped=true"
import script from "./Index-FiscalIssuance.vue?vue&type=script&lang=js"
export * from "./Index-FiscalIssuance.vue?vue&type=script&lang=js"
import style0 from "./Index-FiscalIssuance.vue?vue&type=style&index=0&id=09d65fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d65fec",
  null
  
)

export default component.exports